import MainChatBoard from "../../component/MainChat"

function MainChat() {
  return (
    <div><MainChatBoard/></div>
  )
}

export default MainChat